module.exports = __webpack_public_path__ + "5e0ed37428516ba78345a6279532031f.svg";